"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateBillingChanges = exports.calculateTotals = exports.SurplusLineItem = void 0;
var SurplusLineItem;
(function (SurplusLineItem) {
    SurplusLineItem["INSPECTION_FEE"] = "INSPECTION_FEE";
})(SurplusLineItem = exports.SurplusLineItem || (exports.SurplusLineItem = {}));
function calculateTotals(value) {
    var currentTotal = value.premium.current +
        value.stateTax.current +
        value.stateStampingFee.current +
        value.miscTaxesAndFees.current +
        value.carrierPolicyFee.current +
        value.newfrontFee.current +
        value.wholesaleFee.current;
    var updatedTotal = value.premium.updated +
        value.stateTax.updated +
        value.stateStampingFee.updated +
        value.miscTaxesAndFees.updated +
        value.carrierPolicyFee.updated +
        value.newfrontFee.updated +
        value.wholesaleFee.updated;
    return {
        current: currentTotal,
        updated: updatedTotal,
    };
}
exports.calculateTotals = calculateTotals;
function calculateBillingChanges(current, changes) {
    var carrierPolicyFeeChange = changes.carrierPolicyFeeChange, newfrontFeeUpdate = changes.newfrontFee, miscTaxesAndFeesUpdate = changes.miscTaxesAndFees, premiumChange = changes.premiumChange, stateStampingFeeChange = changes.stateStampingFeeChange, stateTaxChange = changes.stateTaxChange, wholesaleFeeChange = changes.wholesaleFeeChange;
    var carrierPolicyFee = {
        current: current.carrierPolicyFee,
        updated: current.carrierPolicyFee - carrierPolicyFeeChange,
    };
    var newfrontFee = {
        current: current.newfrontFee,
        updated: current.newfrontFee - newfrontFeeUpdate,
    };
    var premium = {
        current: current.premium,
        updated: current.premium - premiumChange,
    };
    var stateTax = {
        current: current.stateTax,
        updated: current.stateTax - stateTaxChange,
    };
    var stateStampingFee = {
        current: current.stateStampingFee,
        updated: current.stateStampingFee - stateStampingFeeChange,
    };
    var miscTaxesAndFees = {
        current: current.miscTaxesAndFees,
        updated: current.miscTaxesAndFees - miscTaxesAndFeesUpdate,
    };
    var wholesaleFee = {
        current: current.wholesaleFee,
        updated: current.wholesaleFee - wholesaleFeeChange,
    };
    return {
        premium: premium,
        stateTax: stateTax,
        stateStampingFee: stateStampingFee,
        miscTaxesAndFees: miscTaxesAndFees,
        newfrontFee: newfrontFee,
        wholesaleFee: wholesaleFee,
        carrierPolicyFee: carrierPolicyFee,
    };
}
exports.calculateBillingChanges = calculateBillingChanges;
//# sourceMappingURL=types.js.map